import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Form, Select, Button, ConfigProvider, Divider, Row, Col } from 'antd';
import { Spinner } from 'reactstrap';
import axios from '../../utils/request';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

export class MaiRui extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            redisKey: "",
            selectionPlanDates: [],
            urgedate: "",
            planDate: "",
            canEditUrge : false
        }
    };
    formRef = React.createRef()

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let offerId = urlParams.get("offerId");
        let tenantId = urlParams.get("tenantId");
        let timestamp = urlParams.get("timestamp");
        let secret = urlParams.get("secret");
        if (!offerId || !tenantId) {
            this.setState({ errorMessage: "offerId或tenantId不存在！", isLoading: false, isReady: true });
            return;
        }
        this.setState({
            tenantId: parseInt(tenantId)
        })
        this.loadPage(offerId, tenantId, timestamp, secret);
    };

    loadPage = (offerId, tenantId, timestamp, secret) => {
        const params = {
            offerId,
            tenantId,
            timestamp,
            secret
        }
        axios
            .get("/api/MaiRui/GetPlanDateIniSelection", { params: params })
            .then(res => {
                const isSuccessValue = res.data.code == "200";
                let resdata = res.data.data;
                let errorMessage = "";
                if (!isSuccessValue) {
                    errorMessage = "初始化失败！" + res.data.message
                } else {
                    if (resdata !== "") {
                        errorMessage = "";
                        let redisKey = resdata.redisKey;
                        let selectionPlanDates = resdata.selectionPlanDates;
                        let planDate = resdata.planDate;

                        this.setState({
                            redisKey: redisKey,
                            selectionPlanDates: selectionPlanDates,
                            canEditUrge: resdata.canEditUrge,
                            planDate: planDate
                        })
                    } else {
                        errorMessage = "初始化失败！";
                    }
                }
                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    onFinish = (values) => {
        let redisKey = this.state.redisKey;
        let tenantId = this.state.tenantId;
        let planDate = this.state.planDate;
        const urlParamsFinish = new URLSearchParams(window.location.search);
        let offerIdKey = urlParamsFinish.get("offerId");
        let timestampKey = urlParamsFinish.get("timestamp");
        let secretKey = urlParamsFinish.get("secret");
        const params = {
            redisKey,
            tenantId,
            planDate,
            offerIdKey,
            timestampKey,
            secretKey
        }
        console.log(params);
        const bodyString = JSON.stringify(params);
        axios
            .post("/api/MaiRui/UpdatePlanDate", bodyString,
                {
                    headers: { "Content-Type": "application/json" }
                })
            .then(res => {
                const isSuccessValue = res.data.code == "200";
                const resback = res.data.message;
                let errorMessage = "";
                if (!isSuccessValue) {
                    errorMessage = "提交失败" + resback
                } else {
                    errorMessage = "提交成功"
                }
                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    postSelectedValue = (value) => {
        if (value !== null && value !== "") {
            this.setState({
                planDate: value
            })
        }
    };

    getShowFormItemOprate = () => {
        const children = [];
        children.push(
            <Form.Item
                name="plandateitem"
                label="预计入职时间"
                required
                rules={[
                    {
                        required: true,
                        message: '请选择预计入职时间',
                    },
                ]}
            >
                <Select showSearch
                    name="plandateselect"
                    placeholder="---请选择预计入职时间---"
                    onChange={this.postSelectedValue}
                    disabled={this.state.canEditUrge ? false : true}
                >
                    {this.state.selectionPlanDates.map(item => <Select.Option key={item.display} value={item.value}>{item.display}</Select.Option>)}
                </Select>
            </Form.Item>
        );
        if (this.state.canEditUrge) {
            children.push(
                <Form.Item>
                    <Button type="primary" disabled={this.state.canEditUrge ? false : true} style={{ float: "right" }} htmlType="submit">提交</Button>
                </Form.Item>
            );
        }
        else {
            children.push(
                <Form.Item>
                    <span style={{ color: "red", float: "right" }}>您已提交,请勿重复提交</span>
                </Form.Item>
            );
        }

        return children;
    }

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
            else {
                return (
                    <ConfigProvider>
                        <div style={{ width: "100%", padding: "25px" }}>
                            <Divider orientation="left" style={{ fontSize: "18px" }}>入职预约</Divider>
                            <Row style={{ marginTop: "15px" }}>
                                <Col span={4}></Col>
                                <Col span={16}>
                                    <Form onFinish={this.onFinish} ref={this.formRef} initialValues={{
                                        plandateitem: this.state.planDate
                                    }}>
                                        {this.getShowFormItemOprate()}
                                    </Form>
                                </Col>
                                <Col span={4}></Col>
                            </Row>

                        </div>
                    </ConfigProvider>
                )
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}